export default "__VITE_ASSET__q0k5gHIZ__"